import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "meeting-rate-container meeting-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-title" }, "Create Meeting Type"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Rate & Time")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = {
  key: 0,
  class: "message-container"
}
const _hoisted_5 = {
  key: 1,
  class: "message-container"
}
const _hoisted_6 = { class: "what-for" }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      ($props.invite.payer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "How much would you like to pay for this meeting and how long is the meeting?"))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, "How much would you like to be paid for this meeting and how long is the meeting?")),
      _createVNode($setup["rateField"], {
        class: _normalizeClass(["rate-field", {'payer-rate': $props.invite.payer}]),
        invite: $props.invite,
        availabilityLen: $setup.availabilityLen,
        amount: $setup.amount,
        "onUpdate:amount": _cache[0] || (_cache[0] = ($event: any) => (($setup.amount) = $event)),
        minutes: $setup.minutes,
        "onUpdate:minutes": _cache[1] || (_cache[1] = ($event: any) => (($setup.minutes) = $event))
      }, null, 8 /* PROPS */, ["invite", "availabilityLen", "amount", "minutes", "class"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "link",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showVideo = true))
      }, "What is a transaction fee for?")
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "borderless previous",
        onClick: $setup.previous
      }, "Back"),
      _createElementVNode("button", {
        class: "borderless confirm-details",
        disabled: !!$props.invite.payer && !$setup.hasAgreed,
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.setRate()))
      }, "Next", 8 /* PROPS */, _hoisted_8)
    ]),
    ($setup.showVideo)
      ? (_openBlock(), _createBlock($setup["PopupVideo"], {
          key: 0,
          videoLink: "transactionFee",
          onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.showVideo = false))
        }))
      : _createCommentVNode("v-if", true)
  ]))
}